/* eslint-disable import/prefer-default-export */
const CONTENT_API = '/content-api/aggregate-pages';
const PRV_CONTENT_API = '/prvcontent-api/aggregate-pages';

const AGGREGATOR_API = '/content-aggregator/aggregate-pages';
const PRV_AGGREGATOR_API = '/prvcontent-aggregator/aggregate-pages';

export default {
    CONTENT_API,
    PRV_CONTENT_API,
    AGGREGATOR_API,
    PRV_AGGREGATOR_API,
};
